/* ========================================================================
   Umbraco Forms
 ========================================================================== */

app.umbracoForms = (function () {
  'use strict';

  let loggedError = false;

  function init() {
    const forms = document.querySelectorAll('.umbraco-forms-form');

    forms.forEach((form) => {
      const submitButtons = form.querySelectorAll('button[type="submit"]');

      form.addEventListener('submit', (event) => {
        LoadingOverlay('body');
      });

      submitButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          if (loggedError) return;

          window.setTimeout(function () {
            const formErrors = form.querySelectorAll('.field-validation-error');

            if (formErrors.length > 0) {
              // DATALAYER
              app.dataLayer.pushEvent('foutmeldingForm', {
                pageUrl: window.location.pathname,
                errorMessage: formErrors[0].innerText,
              });

              loggedError = true;
            }
          }, 250);
        });
      });
    });

    const captchaErrors = document.querySelectorAll('.umbraco-forms-form .ucaptcha .field-validation-error');

    if (captchaErrors.length > 0) {
      // DATALAYER
      app.dataLayer.pushEvent('foutmeldingForm', {
        pageUrl: window.location.pathname,
        errorMessage: captchaErrors[0].innerText,
      });
    }

    // Scroll to form when it has multiple pages and we're showing page > 1
    const formPages = document.querySelectorAll('.umbraco-forms-paging-captions-caption');
    formPages.forEach((page, index) => {
      if (index > 0 && page.classList.contains('umbraco-forms-paging-captions-caption-current')) {
        const formSection = page.closest('.formSection');
        if (formSection) {
          formSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();

app.umbracoForms.init();
